import React, { useEffect, useState } from "react";
import { Button, CircularProgress, FormGroup, TextField, Typography } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import {useFormik} from "formik";
import PropTypes from "prop-types";
import { useOrderDetail } from "../../store/orderDetail";
import { useOrganization } from "../../store/organization";
import { Instructions } from "./components/Instruction";
import { PARTNERS } from "../../utils/constants";
import { Reviews } from "./components/Reviews";

const EnterZip = ({updateZipInformation, toggleDialog}) => {
  const params = useParams();
  const params2 = useParams();
  const [searchParams] = useSearchParams();

  const {zip, zipInformation, getZipInformation} = useOrderDetail();
  const client = searchParams.get("client")?.toLowerCase();
  const {data: organizationData} = useOrganization(
    (state) => state.organization
  );

  const [isOpenedInstruction, setOpenInstruction] = useState(false);

  useEffect(() => {
    window.analytics.track("Register Interest - Enter Zip Visited", {
      url: window.location.href,
      referrer: document.referrer,
      searchParams: searchParams,
      params: params2,
      category: params2.category,
      group: params2.group,
      client: client,
      zip: zip,
    });
    // return () => {
    //   second;
    // };
  }, []);

  const formik = useFormik({
    initialValues: {
      zip: zip || "",
    },
    onSubmit: async (values) => {
      const zipInformationRequestBody = {
        zip: values.zip,
        externalId: "",
        client: client,
      };

      // JR free trial ride
      if (params.freetrialride) {
        zipInformationRequestBody.externalId = params.freetrialride;
      }

      // HomeDepot Transport Assist
      if (params.transport) {
        zipInformationRequestBody.externalId = params.transport;
      }

      // Ordinary HomeDepot product
      if (params.group && params.category) {
        zipInformationRequestBody.externalId = `${params.category}-${params.group}`;
      }

      const zipInfo = await getZipInformation(
        ...Object.values(zipInformationRequestBody)
      );

      updateZipInformation(values.zip, zipInfo);
    },
    validationSchema: yup.object().shape({
      zip: yup.string().required("Zip code is required"),
    }),
  });

  return (
    <div className="unserviced-zip tw-flex tw-flex-col tw-justify-center tw-pt-8 tw-px-6">
      <Typography
        variant="p"
        className="tw-pt-5 tw-pb-5 tw-text-center tw-whitespace-pre-wrap tw-text-sm"
      >
        {organizationData.popupInServiceCopy}
      </Typography>

      <form onSubmit={formik.handleSubmit}>
        <FormGroup>
          <TextField
            id="zip"
            label="Your Zip Code"
            variant="standard"
            name="zip"
            value={formik.values.zip}
            error={formik.touched.zip && Boolean(formik.errors.zip)}
            onChange={formik.handleChange}
          />
          {formik.errors.zip && (
            <span style={{ color: "red", fontSize: "13px" }}>
              {formik.errors.zip}
            </span>
          )}
        </FormGroup>

        <Button
          fullWidth={true}
          variant="contained"
          type="submit"
          style={{
            backgroundColor: "#333",
            height: "50px",
            marginTop: "25px",
            marginBottom: "15px",
            color: "#ffffff",
          }}
        >
          {zipInformation.isLoading ? (
            <CircularProgress size={25} color="inherit" />
          ) : (
            "Continue"
          )}
        </Button>

        {organizationData.instructions && (
          <p
            onClick={() => {
              window.analytics.track(
                "Register Interest - Clicked How it Works",
                {
                  url: window.location.href,
                  referrer: document.referrer,
                  searchParams: searchParams,
                  params: params,
                  client: searchParams.get("client")?.toLowerCase(),
                  zip: formik.values.zip,
                }
              );
              setOpenInstruction(true);
              toggleDialog("none");
            }}
            className="tw-text-skiptiOrange tw-cursor-pointer tw-underline tw-text-center tw-mb-6"
          >
            How does this work?
          </p>
        )}
      </form>

      {isOpenedInstruction && (
        <Instructions onClose={() => {
          setOpenInstruction(false);
          toggleDialog("block");
        }}/>
      )}

      <Reviews />
    </div>
  );
};

EnterZip.propTypes = {
  updateZipInformation: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
};

export default EnterZip;
